<!-- Aliased once for the header, content and footer, which an @if alias cannot span. -->
@let contacted = contactedEmployee();

<sb-dialog-header>
  @if (contacted) {
    <h3 sb-dialog-title data-hj-suppress>
      {{ 'Contact [name]' | translate: { name: contacted.name } }}
    </h3>
  } @else {
    <h3 sb-dialog-title>{{ 'Find cover for this shift' | translate }}</h3>
  }
</sb-dialog-header>

<sb-dialog-content>
  <div class="flex flex-col gap-md">
    @if (shift(); as coveredShift) {
      <find-cover-shift-row [shift]="coveredShift">
        <span class="text-sm text-support">
          {{ coveredShift.date | localeDate: 'weekdayMedium' }}
          @if (shiftPlacement(); as placement) {
            · {{ placement }}
          }
        </span>
      </find-cover-shift-row>
    }

    @if (contacted) {
      <sb-card>
        <div class="flex items-center gap-md p-md">
          <sb-icon-badge aria-hidden="true" icon="phone-regular" color="green" appearance="filled" />

          <div class="flex grow flex-col">
            <span class="text-base font-bold text-default">{{ 'Call or message' | translate }}</span>

            @if (contactPhoneNumber(); as phoneNumber) {
              <span class="text-sm text-support" data-hj-suppress>{{ phoneNumber }}</span>
            } @else {
              <span class="text-sm text-support">{{ 'No phone number on record' | translate }}</span>
            }
          </div>

          @if (contactPhoneHref(); as phoneHref) {
            <a sb-button color="secondary" [href]="phoneHref" data-hj-suppress>
              <sb-icon name="phone-regular" size="xs" />
              {{ 'Call' | translate }}
            </a>
          }
        </div>
      </sb-card>
    } @else if (isLoading()) {
      <sb-loading-state [label]="'Finding the best fit employees...' | translate" />
    } @else if (isIncomplete()) {
      <sb-empty-state
        icon="alert-regular"
        [title]="'This shift needs more detail' | translate"
        [description]="'We need a team and a shift type on this shift before we can recommend anyone.' | translate"
      />
    } @else if (isUnavailable()) {
      <sb-empty-state
        icon="alert-regular"
        [title]="'Recommendations are temporarily unavailable' | translate"
        [description]="'We could not reach the recommendation service. Please try again in a moment.' | translate"
      />
    } @else if (hasError()) {
      <sb-empty-state
        icon="close-circle-regular"
        [description]="'Something went wrong, please try again.' | translate"
      />
    } @else if (rows().length === 0) {
      <sb-empty-state
        icon="empty-box-regular"
        [title]="'No one available to cover' | translate"
        [description]="
          'Nobody is eligible for this shift right now. Adjust the team or the shift requirements, then check again.'
            | translate
        "
      />
    } @else {
      <best-fit-employee-list
        [rows]="rows()"
        [listLabel]="'Employees who can cover this shift' | translate"
        [showCoc]="!!showCoc()"
        [(selectedEmployeeIds)]="selectedEmployeeIds"
      />
    }
  </div>
</sb-dialog-content>

<sb-dialog-footer>
  @if (contacted) {
    <sb-dialog-footer-actions>
      <button sb-button color="secondary" type="button" (click)="closeContact()">
        {{ 'Back' | translate }}
      </button>
    </sb-dialog-footer-actions>
  } @else {
    @if (isStepper) {
      <span class="text-sm text-support">
        {{ 'Shift [current] of [total]' | translate: { current: stepNumber(), total: totalSteps } }}
      </span>
    }

    <sb-checkbox [(ngModel)]="notifyEmployee">{{ 'Notify employee' | translate }}</sb-checkbox>

    <sb-dialog-footer-actions [align]="'end'">
      @if (isStepper) {
        <button sb-button color="secondary" type="button" [disabled]="isSaving()" (click)="skip()">
          {{ 'Skip' | translate }}
        </button>
      }

      @if (hasSelection()) {
        <button sb-button color="secondary" type="button" (click)="openContact()">
          <sb-icon name="phone-regular" size="xs" />
          {{ 'Contact' | translate }}
        </button>
      }

      <button
        sb-button
        color="primary"
        type="button"
        [sbLadda]="isSaving()"
        [disabled]="!hasSelection() || isSaving()"
        (click)="reassign()"
      >
        @if (!isStepper) {
          {{ 'Reassign' | translate }}
        } @else if (isLastStep()) {
          {{ 'Assign & finish' | translate }}
        } @else {
          {{ 'Assign & next' | translate }}
        }
      </button>
    </sb-dialog-footer-actions>
  }
</sb-dialog-footer>
